import SmallEmptyOpenedBox from "static/images/SmallEmptyOpenedBox.svg";

export const SmallEmptyOpenBox = ({ text }: { text: string }) => {
  return (
    <div className="t-flex t-items-center t-justify-center t-gap-4 t-flex-col t-h-full">
      <img src={SmallEmptyOpenedBox} alt="SmallEmptyOpenedBox" />
      <span className="t-text-body t-text-text-30">{text}</span>
    </div>
  );
};
